// Phone formatting per UI language (the language defines the country pattern).
const RULES = {
  pt: { cc: "55", max: 11, fmt: (d) => d.length <= 2 ? (d ? `(${d}` : "") : `(${d.slice(0, 2)})${d.slice(2, 7)}${d.length > 7 ? "-" + d.slice(7, 11) : ""}` },
  en: { cc: "1", max: 10, fmt: (d) => d.length <= 3 ? (d ? `(${d}` : "") : `(${d.slice(0, 3)}) ${d.slice(3, 6)}${d.length > 6 ? "-" + d.slice(6, 10) : ""}` },
  es: { cc: "34", max: 9, fmt: (d) => [d.slice(0, 3), d.slice(3, 6), d.slice(6, 9)].filter(Boolean).join(" ") },
  fr: { cc: "33", max: 10, fmt: (d) => (d.match(/.{1,2}/g) || []).join(" ") },
  it: { cc: "39", max: 10, fmt: (d) => [d.slice(0, 3), d.slice(3, 6), d.slice(6, 10)].filter(Boolean).join(" ") },
};
RULES["pt-PT"] = { cc: "351", max: 9, fmt: (d) => [d.slice(0, 3), d.slice(3, 6), d.slice(6, 9)].filter(Boolean).join(" ") };
const rule = (lang) => RULES[lang] || RULES.pt;

export const PHONE_EXAMPLE = { pt: "(21)99542-1234", "pt-PT": "912 345 678", en: "(212) 555-0199", es: "612 345 678", fr: "06 12 34 56 78", it: "312 345 6789" };

// National digits typed by the user -> masked display (as they type)
export function maskPhone(lang, raw) {
  const r = rule(lang);
  const d = String(raw || "").replace(/\D/g, "").slice(0, r.max);
  return r.fmt(d);
}

// Masked national input -> digits with country code (what we store / use for wa.me)
export function toStoredPhone(lang, masked) {
  const r = rule(lang);
  const d = String(masked || "").replace(/\D/g, "");
  if (!d) return "";
  return d.length > r.max && d.startsWith(r.cc) ? d : r.cc + d;
}

// Stored digits (with country code) -> masked national display, e.g. 5521995421234 -> (21)99542-1234
export function displayPhone(lang, stored) {
  const r = rule(lang);
  const d = String(stored || "").replace(/\D/g, "");
  if (!d) return "";
  const national = d.startsWith(r.cc) && d.length > r.max ? d.slice(r.cc.length) : d;
  return national.length <= r.max ? r.fmt(national) : `+${d}`;
}
